import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { HttpUtilityService } from "src/app/http/http-utility.service";
import { EventEmitter } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  public resetFormEvent: EventEmitter<any>;
    public endpoint = 'https://4cn1mzsteh.execute-api.us-west-1.amazonaws.com/dev/api/';//'https://api-comm-dev.sacramentoda.org/ycc/api/';
    public httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };
  constructor(private http: HttpClient,
  private _httpService: HttpUtilityService) {

       this.resetFormEvent = new EventEmitter<any>();
  }
  private extractData(res: Response) {
    const body = res;
    return body || { };
  }
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
  getTime (): any {
    console.log();
  let time = [

{'Text':'7:00 AM', 'Value':'7:00 AM'},
{'Text':'7:30 AM', 'Value':'7:30 AM'},
{'Text':'8:00 AM', 'Value':'8:00 AM'},
{'Text':'8:30 AM', 'Value':'8:30 AM'},
{'Text':'9:00 AM', 'Value':'9:00 AM'},
{'Text':'9:30 AM', 'Value':'9:30 AM'},
{'Text':'10:00 AM', 'Value':'10:00 AM'},
{'Text':'10:30 AM', 'Value':'10:30 AM'},
{'Text':'11:00 AM', 'Value':'11:00 AM'},
{'Text':'11:30 AM', 'Value':'11:30 AM'},
{'Text':'12:00 PM', 'Value':'12:00 PM'},
{'Text':'12:30 PM', 'Value':'12:30 PM'},
{'Text':'1:00 PM', 'Value':'1:00 PM'},
{'Text':'1:30 PM', 'Value':'1:30 PM'},
{'Text':'2:00 PM', 'Value':'2:00 PM'},
{'Text':'2:30 PM', 'Value':'2:30 PM'},
{'Text':'3:00 PM', 'Value':'3:00 PM'},
{'Text':'3:30 PM', 'Value':'3:30 PM'},
{'Text':'4:00 PM', 'Value':'4:00 PM'},
{'Text':'4:30 PM', 'Value':'4:30 PM'},
{'Text':'5:00 PM', 'Value':'5:00 PM'},
{'Text':'5:30 PM', 'Value':'5:30 PM'},
{'Text':'6:00 PM', 'Value':'6:00 PM'},
{'Text':'6:30 PM', 'Value':'6:30 PM'},
{'Text':'7:00 PM', 'Value':'7:00 PM'},
{'Text':'7:30 PM', 'Value':'7:30 PM'},
{'Text':'8:00 PM', 'Value':'8:00 PM'},
{'Text':'8:30 PM', 'Value':'8:30 PM'},
{'Text':'9:00 PM', 'Value':'9:00 PM'},
{'Text':'9:30 PM', 'Value':'9:30 PM'},
{'Text':'10:00 PM', 'Value':'10:00 PM'},
{'Text':'10:30 PM', 'Value':'10:30 PM'}];
  return time;
  }

  getStates (): any {
    console.log();
  let states = [
{'Value':'AL', 'Text':'Alabama'},
{'Value':'AK', 'Text':'Alaska'},
{'Value':'AZ', 'Text':'Arizona'},
{'Value':'AR', 'Text':'Arkansas'},
{'Value':'CA', 'Text':'California'},
{'Value':'CO', 'Text':'Colorado'},
{'Value':'CT', 'Text':'Connecticut'},
{'Value':'DE', 'Text':'Delaware'},
{'Value':'DC', 'Text':'District Of Columbia'},
{'Value':'FL', 'Text':'Florida'},
{'Value':'GA', 'Text':'Georgia'},
{'Value':'HI', 'Text':'Hawaii'},
{'Value':'ID', 'Text':'Idaho'},
{'Value':'IL', 'Text':'Illinois'},
{'Value':'IN', 'Text':'Indiana'},
{'Value':'IA', 'Text':'Iowa'},
{'Value':'KS', 'Text':'Kansas'},
{'Value':'KY', 'Text':'Kentucky'},
{'Value':'LA', 'Text':'Louisiana'},
{'Value':'ME', 'Text':'Maine'},
{'Value':'MD', 'Text':'Maryland'},
{'Value':'MA', 'Text':'Massachusetts'},
{'Value':'MI', 'Text':'Michigan'},
{'Value':'MN', 'Text':'Minnesota'},
{'Value':'MS', 'Text':'Mississippi'},
{'Value':'MO', 'Text':'Missouri'},
{'Value':'MT', 'Text':'Montana'},
{'Value':'NE', 'Text':'Nebraska'},
{'Value':'NV', 'Text':'Nevada'},
{'Value':'NH', 'Text':'New Hampshire'},
{'Value':'NJ', 'Text':'New Jersey'},
{'Value':'NM', 'Text':'New Mexico'},
{'Value':'NY', 'Text':'New York'},
{'Value':'NC', 'Text':'North Carolina'},
{'Value':'ND', 'Text':'North Dakota'},
{'Value':'OH', 'Text':'Ohio'},
{'Value':'OK', 'Text':'Oklahoma'},
{'Value':'OR', 'Text':'Oregon'},
{'Value':'PA', 'Text':'Pennsylvania'},
{'Value':'RI', 'Text':'Rhode Island'},
{'Value':'SC', 'Text':'South Carolina'},
{'Value':'SD', 'Text':'South Dakota'},
{'Value':'TN', 'Text':'Tennessee'},
{'Value':'TX', 'Text':'Texas'},
{'Value':'UT', 'Text':'Utah'},
{'Value':'VT', 'Text':'Vermont'},
{'Value':'VA', 'Text':'Virginia'},
{'Value':'WA', 'Text':'Washington'},
{'Value':'WV', 'Text':'West Virginia'},
{'Value':'WI', 'Text':'Wisconsin'},
{'Value':'WY', 'Text':'Wyoming'}];
  return states;
}

getAgeTypes () :any {

  let ageTypes = [
                  {'Id':1, 'Value':'Ages (0-5 years)', 'Text':'Ages (0-5 years)'},
                  {'Id':2, 'Value':'Elementary (5-12 years)', 'Text':'Elementary (5-12 years)'},
                  {'Id':3, 'Value':'Youth (13-18 years)', 'Text':'Youth (13-18 years)'},
                  {'Id':4, 'Value':'Youth (18+)', 'Text':'Youth (18+)'},
                  {'Id':5, 'Value':'All the above', 'Text':'All the above'}]
  return ageTypes;
}

getResources () :any {

  let resources = [
    {'Id':1, 'Value':'Academic Tutoring', 'Text':'Academic Tutoring'},
{'Id':2, 'Value':'Alternative Education', 'Text':'Alternative Education'},
{'Id':3, 'Value':'Before/After School Program(s)', 'Text':'Before/After School Program(s) '},
{'Id':4, 'Value':'Career Education Program(s)', 'Text':'Career Education Program(s)'},
{'Id':5, 'Value':'Clothing', 'Text':'Clothing'},
{'Id':6, 'Value':'Conflict Management', 'Text':'Conflict Management'},
{'Id':7, 'Value':'Counseling (drug, alcohol, anger…)', 'Text':'Counseling (drug, alcohol, anger…)'},
{'Id':8, 'Value':'Criminal Justice Program(s)', 'Text':'Criminal Justice Program(s)'},
{'Id':9, 'Value':'Domestic Violence Program(s)', 'Text':'Domestic Violence Program(s)'},
{'Id':10, 'Value':'Employment', 'Text':'Employment'},
{'Id':11, 'Value':'Family Outreach Program(s)', 'Text':'Family Outreach Program(s)'},
{'Id':12, 'Value':'Fitness', 'Text':'Fitness'},
{'Id':13, 'Value':'Food', 'Text':'Food'},
{'Id':14, 'Value':'Health & Nutrition', 'Text':'Health & Nutrition'},
{'Id':15, 'Value':'Housing/Shelter', 'Text':'Housing/Shelter'},
{'Id':16, 'Value':'Human Trafficking Program(s)', 'Text':'Human Trafficking Program(s)'},
{'Id':17, 'Value':'Internship Opportunities', 'Text':'Internship Opportunities'},
{'Id':18, 'Value':'LGBT Program(s)', 'Text':'LGBT Program(s)'},
{'Id':19, 'Value':'Life Skill Program(s)', 'Text':'Life Skill Program(s)'},
{'Id':20, 'Value':'Mental Health', 'Text':'Mental Health'},
{'Id':21, 'Value':'Mentoring Program(s)', 'Text':'Mentoring Program(s)'},
{'Id':22, 'Value':'Parenting Program(s)', 'Text':'Parenting Program(s)'},
{'Id':23, 'Value':'Performing Arts Program(s)', 'Text':'Performing Arts Program(s)'},
{'Id':24, 'Value':'Recreation Program(s)', 'Text':'Recreation Program(s)'},
{'Id':25, 'Value':'Sports Program(s)', 'Text':'Sports Program(s)'},
{'Id':26, 'Value':'Suicide Prevention', 'Text':'Suicide Prevention'},
{'Id':27, 'Value':'Summer Program(s)', 'Text':'Summer Program(s)'},
{'Id':28, 'Value':'Volunteer', 'Text':'Volunteer'},
{'Id':29, 'Value':'Youth Academy Program(s)', 'Text':'Youth Academy Program(s)'},
{'Id':30, 'Value':'Youth Intervention and Prevention Program(s)', 'Text':'Youth Intervention and Prevention Program(s)'}

  ]
  return resources;
}
  getLanguages (): any {
    console.log();
  let time = [
  {'Id':1, 'Value':'English', 'Text':'English'},
  {'Id':2, 'Value':'Spanish', 'Text':'Spanish'},
  {'Id':3, 'Value':'Afrikanns', 'Text':'Afrikanns'},
  {'Id':4, 'Value':'Albanian', 'Text':'Albanian'},
  {'Id':5, 'Value':'Arabic', 'Text':'Arabic'},
  {'Id':6, 'Value':'Armenian', 'Text':'Armenian'},
  {'Id':7, 'Value':'Basque', 'Text':'Basque'},
  {'Id':8, 'Value':'Bengali', 'Text':'Bengali'},
  {'Id':9, 'Value':'Bulgarian', 'Text':'Bulgarian'},
  {'Id':10, 'Value':'Catalan', 'Text':'Catalan'},
  {'Id':11, 'Value':'Cambodian', 'Text':'Cambodian'},
  {'Id':12, 'Value':'Chinese (Mandarin)', 'Text':'Chinese (Mandarin)'},
  {'Id':13, 'Value':'Croation', 'Text':'Croation'},
  {'Id':14, 'Value':'Czech', 'Text':'Czech'},
  {'Id':15, 'Value':'Danish', 'Text':'Danish'},
  {'Id':16, 'Value':'Dutch', 'Text':'Dutch'},  
  {'Id':17, 'Value':'Estonian', 'Text':'Estonian'},
  {'Id':18, 'Value':'Fiji', 'Text':'Fiji'},
  {'Id':19, 'Value':'Finnish', 'Text':'Finnish'},
  {'Id':20, 'Value':'French', 'Text':'French'},
  {'Id':21, 'Value':'Georgian', 'Text':'Georgian'},
  {'Id':22, 'Value':'German', 'Text':'German'},
  {'Id':23, 'Value':'Greek', 'Text':'Greek'},
  {'Id':24, 'Value':'Gujarati', 'Text':'Gujarati'},
  {'Id':25, 'Value':'Hebrew', 'Text':'Hebrew'},
  {'Id':26, 'Value':'Hindi', 'Text':'Hindi'},
  {'Id':27, 'Value':'Hungarian', 'Text':'Hungarian'},
  {'Id':28, 'Value':'Icelandic', 'Text':'Icelandic'},
  {'Id':29, 'Value':'Indonesian', 'Text':'Indonesian'},
  {'Id':30, 'Value':'Irish', 'Text':'Irish'},
  {'Id':31, 'Value':'Italian', 'Text':'Italian'},
  {'Id':32, 'Value':'Japanese', 'Text':'Japanese'},
  {'Id':33, 'Value':'Javanese', 'Text':'Javanese'},
  {'Id':34, 'Value':'Korean', 'Text':'Korean'},
  {'Id':35, 'Value':'Latin', 'Text':'Latin'},
  {'Id':36, 'Value':'Latvian', 'Text':'Latvian'},
  {'Id':37, 'Value':'Lithuanian', 'Text':'Lithuanian'},
  {'Id':38, 'Value':'Macedonian', 'Text':'Macedonian'},
  {'Id':39, 'Value':'Malay', 'Text':'Malay'},
  {'Id':40, 'Value':'Malayalam', 'Text':'Malayalam'},
  {'Id':41, 'Value':'Maltese', 'Text':'Maltese'},
  {'Id':42, 'Value':'Maori', 'Text':'Maori'},
  {'Id':43, 'Value':'Marathi', 'Text':'Marathi'},
  {'Id':44, 'Value':'Mongolian', 'Text':'Mongolian'},
  {'Id':45, 'Value':'Nepali', 'Text':'Nepali'},
  {'Id':46, 'Value':'Norwegian', 'Text':'Norwegian'},
  {'Id':47, 'Value':'Persian', 'Text':'Persian'},
  {'Id':48, 'Value':'Polish', 'Text':'Polish'},
  {'Id':49, 'Value':'Portuguese', 'Text':'Portuguese'},
  {'Id':50, 'Value':'Punjabi', 'Text':'Punjabi'},
  {'Id':51, 'Value':'Quechua', 'Text':'Quechua'},
  {'Id':52, 'Value':'Romanian', 'Text':'Romanian'},
  {'Id':53, 'Value':'Russian', 'Text':'Russian'},
  {'Id':54, 'Value':'Samoan', 'Text':'Samoan'},
  {'Id':55, 'Value':'Serbian', 'Text':'Serbian'},
  {'Id':56, 'Value':'Slovak', 'Text':'Slovak'},
  {'Id':57, 'Value':'Slovenian', 'Text':'Slovenian'},  
  {'Id':58, 'Value':'Swahili', 'Text':'Swahili'},
  {'Id':59, 'Value':'Swedish', 'Text':'Swedish'},
  {'Id':60, 'Value':'Tamil', 'Text':'Tamil'},
  {'Id':61, 'Value':'Tatar', 'Text':'Tatar'},
  {'Id':62, 'Value':'Telugu', 'Text':'Telugu'},
  {'Id':63, 'Value':'Thai', 'Text':'Thai'},
  {'Id':64, 'Value':'Tibetan', 'Text':'Tibetan'},
  {'Id':65, 'Value':'Tonga', 'Text':'Tonga'},
  {'Id':66, 'Value':'Turkish', 'Text':'Turkish'},
  {'Id':67, 'Value':'Ukranian', 'Text':'Ukranian'},
  {'Id':68, 'Value':'Urdu', 'Text':'Urdu'},
  {'Id':69, 'Value':'Uzbek', 'Text':'Uzbek'},
  {'Id':70, 'Value':'Vietnamese', 'Text':'Vietnamese'},
  {'Id':71, 'Value':'Welsh', 'Text':'Welsh'},
  {'Id':72, 'Value':'Xhosa', 'Text':'Xhosa'}];
  return time;
}

  

public getallResources(): Observable<any> {
    let uri = 'resource/getallresources';
    return this._httpService.get(uri);
  }

  public getallZipcodes(): Observable<any> {
    let uri = 'zipcode/getallzipcodes';
    return this._httpService.get(uri);
  }

   public getallLanguages(): Observable<any> {
    let uri = 'language/getalllanguages';
    return this._httpService.get(uri);
  }



  newRegistration1 (request): Observable<any> {
    console.log(request);
    return this.http.post<any>(this.endpoint + 'registration/newRequest', JSON.stringify(request), this.httpOptions).pipe(
      tap((result) => console.log(result)),
      catchError(this.handleError<any>('addProduct'))
    );
  }

  public resetForm(value) {
      this.resetFormEvent.emit(value);
 }
}
